import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
} from '@mui/material';
import {
  Info as InfoIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
} from '@mui/icons-material';
import { useCreateNotification } from '../hooks/useCreateNotification';

const NotificationExample: React.FC = () => {
  const createNotification = useCreateNotification();

  const notificationTypes = [
    {
      type: 'info',
      icon: <InfoIcon color="info" />,
      title: 'Notificação de Informação',
      description: 'Exemplo de notificação do tipo informação',
    },
    {
      type: 'success',
      icon: <CheckCircleIcon color="success" />,
      title: 'Notificação de Sucesso',
      description: 'Exemplo de notificação do tipo sucesso',
    },
    {
      type: 'warning',
      icon: <WarningIcon color="warning" />,
      title: 'Notificação de Aviso',
      description: 'Exemplo de notificação do tipo aviso',
    },
    {
      type: 'error',
      icon: <ErrorIcon color="error" />,
      title: 'Notificação de Erro',
      description: 'Exemplo de notificação do tipo erro',
    },
  ];

  const handleCreateNotification = (type: 'info' | 'success' | 'warning' | 'error') => {
    const notification = notificationTypes.find(n => n.type === type);
    if (notification) {
      createNotification({
        title: notification.title,
        message: notification.description,
        type,
      });
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Exemplo de Notificações
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Clique nos botões abaixo para testar diferentes tipos de notificações.
      </Typography>

      <Grid container spacing={2}>
        {notificationTypes.map((notification) => (
          <Grid item xs={12} sm={6} md={3} key={notification.type}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  {notification.icon}
                  <Typography variant="h6" component="div" sx={{ ml: 1 }}>
                    {notification.title}
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {notification.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleCreateNotification(notification.type as any)}
                >
                  Testar Notificação
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default NotificationExample; 